export default __webpack_public_path__ + "static/media/process-preview.69db397b.png";